import axios from "axios";
import { baseUrl } from "../config/constants";

// A browser remembered after an emailed sign-in code (RM-3849).
export interface TrustedDevice {
  id: number;
  browser: string | null;
  os: string | null;
  deviceType: string | null;
  ip: string | null;
  city: string | null;
  country: string | null;
  createdAt: string;
  lastUsedAt: string | null;
  expiresAt: string;
}

export default {
  updatePassword: async (current_password: string, password: string) => {
    const res = await axios.put(`${baseUrl}/my/password`, { current_password, password });
    return res.data;
  },
  updatePhone: async (phone: string, current_password: string) => {
    const res = await axios.put(`${baseUrl}/my/phone`, { phone, current_password });
    return res.data;
  },
  updateEmail: async (email: string, current_password: string) => {
    const res = await axios.put(`${baseUrl}/my/email`, { email, current_password });
    return res.data;
  },
  updateProfile: async (data: {
    first_name?: string;
    last_name?: string;
    // A `data:` URI to set/replace the photo, `null` to remove it, or omitted
    // when the photo is unchanged.
    avatar?: string | null;
  }) => {
    const res = await axios.put(`${baseUrl}/my/profile`, data);
    return res.data;
  },
  getTrustedDevices: async (): Promise<TrustedDevice[]> => {
    const res = await axios.get(`${baseUrl}/my/trusted_devices`);
    return res.data.trusted_devices;
  },
  removeTrustedDevice: async (id: number) => {
    const res = await axios.delete(`${baseUrl}/my/trusted_devices/${id}`);
    return res.data;
  },
  removeAllTrustedDevices: async () => {
    const res = await axios.delete(`${baseUrl}/my/trusted_devices`);
    return res.data;
  },
  forgotPassword: async (email: string) => {
    const res = await axios.post(`${baseUrl}/passwords/forgot`, { email });
    return res.data;
  },
  resetPassword: async (reset_password_token: string, password: string) => {
    const res = await axios.put(`${baseUrl}/passwords/reset`, {
      reset_password_token,
      password,
      password_confirmation: password,
    });
    return res.data;
  },
};
